import React, { useContext } from "react";
import Pricing from "./Pricing";
import FAQContactSection from "../FAQContactSection";
import Navbar from "../../common/Navbar";
import { FaArrowRight } from "react-icons/fa";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import Footer from "../../common/Footer";
import MyContext from "../../../../../MyContext";

const pricingData = [
  {
    feature: "Campaign Limit",
    free: "Up to 10 Campaigns",
    enterprise: "Unlimited Campaigns",
  },
  {
    feature: "Broadcast Messages",
    free: "Limited",
    enterprise: "Unlimited",
  },
  {
    feature: "Template Creation",
    free: "Create up to 15 Templates",
    enterprise: "Unlimited Template Creation",
  },
  {
    feature: "Contact Management",
    free: "Basic",
    enterprise: "Advanced",
  },
  {
    feature: "WhatsApp Chat Inbox",
    free: "Shared Inbox",
    enterprise: "Advanced Team Inbox",
  },
  {
    feature: "User Access",
    free: "5–10 Team Members",
    enterprise: "Unlimited Team Members",
  },
  {
    feature: "Chatbot / Automation Flow",
    free: "Basic",
    enterprise: "Advanced Automation",
  },
  {
    feature: "Analytics & Reports",
    free: "Basic Analytics",
    enterprise: "Advanced Analytics & Insights",
  },
  {
    feature: "Export Report",
    free: "Limited",
    enterprise: "Unlimited",
  },
  {
    feature: "Customer Support",
    free: "Email Support",
    enterprise: "Priority Support",
  },
];

export default function PricingPage() {
  const { openFreeTrialModal } = useContext(MyContext);

  return (
    <div className="bg-3-gradient pt-3 pt-md-5">
      <Navbar />
      <section className="py-5  py-md-6 px-3 font-inter">
        <header className="text-center mx-auto" style={{ maxWidth: "768px" }}>
          <h2
            className="fw-semibold"
            style={{
              fontFamily: "Bricolage Grotesque, sans-serif",
              fontSize: "2rem",
              lineHeight: "1.2",
              color: "#ffffff",
            }}
          >
            Choose a plan that’s right for your
          </h2>
          <p
            className="mt-2 text-yellowgreen"
            style={{ fontSize: "1rem", fontWeight: 300 }}
          >
            Try our free plan risk free for 7 days. switch plans or cancel
            anytime.
          </p>
        </header>
        <div className="d-flex justify-content-center mt-5 px-3">
          <div
            className="
                glass-card
                d-flex
                align-items-center
                gap-2 gap-sm-3
                py-2 px-2 px-sm-3
                rounded-pill
                flex-wrap flex-sm-nowrap
              "
          >
            <div
              className="
                  d-flex
                  align-items-center
                  justify-content-center
                  px-3 px-sm-4
                  py-1
                  bg-light-white
                  border
                  rounded-pill
                "
            >
              <p className="mb-0 font-bricolage fw-semibold small small-sm">
                Monthly
              </p>
            </div>

            <p className="mb-0 font-bricolage fw-semibold text-light-white small text-nowrap">
              Yearly 40% off
            </p>
          </div>
        </div>

        <div className="container  my-5">
          <div className="row  mb-4 gx-3">
            <div className="col-12 col-lg mb-3 mb-lg-0">
              <div className="glass-card rounded-5 shadow px-4 py-4 d-flex flex-column justify-content-between h-100 border border-light border-opacity-10">
                <div>
                  <h5 className="fw-medium fs-4 font-bricolage text-light-white">
                    Basic
                  </h5>
                  <p className="mb-3 text-light-white small opacity-75">
                    Best for personal use.
                  </p>
                </div>
                <div className="d-flex align-items-baseline gap-1 text-light-white">
                  <span className="fs-1 font-bricolage fw-medium">₹0</span>
                  <span className="small opacity-75">/ month</span>
                </div>
                <button
                  onClick={openFreeTrialModal}
                  className="btn mt-3 btn-outline-demo rounded-pill fw-semibold w-100"
                >
                  Start Free Trial
                </button>
              </div>
            </div>

            <div className="col-12 col-lg">
              <div className="glass-card rounded-5 shadow px-4 py-4 d-flex flex-column justify-content-between h-100 border border-light border-opacity-10">
                <div>
                  <h5 className="fw-medium fs-4 font-bricolage text-light-white">
                    Enterprise
                  </h5>
                  <p className="mb-3 text-light-white small opacity-75">
                    Best for growing teams.
                  </p>
                </div>
                <div className="d-flex align-items-baseline gap-1">
                  <span className="fs-1 font-bricolage text-yellowgreen fw-medium">
                    ₹2499
                  </span>
                  <span className="fw-light text-light-white small opacity-75">
                    / month
                  </span>
                </div>
                <button className="btn mt-3 btn-outline-google rounded-pill fw-semibold d-flex align-items-center justify-content-center gap-2 w-100">
                  Buy Now <FaArrowRight size={14} />
                </button>
              </div>
            </div>
          </div>

          <div className="pricing-table mt-5 text-white font-inter rounded-4 overflow-hidden border border-light border-opacity-10">
            <div className="overflow-x-auto">
              <div style={{ minWidth: "800px" }}>
                <div
                  className="d-grid py-3 fw-semibold border-bottom border-light border-opacity-25"
                  style={{
                    gridTemplateColumns: "1.2fr 1fr 1fr",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                  }}
                >
                  <div className="font-bricolage fs-4">Features</div>
                  <div className="font-bricolage fs-4 px-3 ">Free Trial</div>
                  <div className="font-bricolage fs-4 px-3 ">Enterprise</div>
                </div>

                {pricingData.map((item, index) => (
                  <div
                    key={index}
                    className="d-grid py-3 align-items-center border-bottom border-light border-opacity-10"
                    style={{
                      gridTemplateColumns: "1.2fr 1fr 1fr",
                      paddingLeft: "1.5rem",
                      paddingRight: "1.5rem",
                    }}
                  >
                    <div className="fs-6 fw-light opacity-75">
                      {item.feature}
                    </div>

                    <div className="d-flex fs-6 fw-light align-items-center  gap-2 px-3 border-start border-light border-opacity-10">
                      <IoIosCheckmarkCircleOutline
                        size={20}
                        className="text-white opacity-50"
                      />
                      <span>{item.free}</span>
                    </div>

                    <div className="d-flex fs-6 fw-light align-items-center    gap-2 px-3 border-start border-light border-opacity-10">
                      <IoIosCheckmarkCircleOutline
                        size={20}
                        className="text-white opacity-50"
                      />
                      <span>{item.enterprise}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <FAQContactSection />
      <Footer />
    </div>
  );
}
